import { render, staticRenderFns } from "./SimuladoProvaView.vue?vue&type=template&id=9386a980&"
import script from "./SimuladoProvaView.vue?vue&type=script&lang=js&"
export * from "./SimuladoProvaView.vue?vue&type=script&lang=js&"
import style0 from "./SimuladoProvaView.vue?vue&type=style&index=0&id=9386a980&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports